import {apiTs} from '../../../services/api';

export const PhotosHTTP = {
  get: (params = {}) => apiTs.get('/photos', {params}),
};
